"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All translations related to login data
var Login = {
  login: {
    nl: 'Meld je aan',
    fr: 'Connecter',
    en: 'Log in',
    de: 'Anmelden'
  },
  logout: {
    nl: 'Meld je af',
    fr: 'Deconnecter',
    en: 'Log out',
    de: 'Abmelden'
  },
  instructions: {
    nl: 'Stuur mij instructies',
    fr: 'Envoie moi des instructions',
    en: 'Send me instructions',
    de: 'Sende mir Anweisungen'
  },
  username: {
    nl: 'Gebruikersnaam',
    fr: "Nom d'utilisateur",
    en: 'Username',
    de: 'Benutzername'
  },
  password: {
    nl: 'Wachtwoord',
    fr: 'Mot de passe',
    en: 'Password',
    de: 'Passwort'
  },
  password_repeat: {
    nl: 'Wachtwoord herhalen',
    fr: 'Répéter le mot de passe',
    en: 'Repeat password',
    de: 'Passwort wiederholen'
  },
  password_forgot: {
    nl: 'Wachtwoord vergeten?',
    fr: 'Oublié mot de passe ?',
    en: 'Forgot password?',
    de: 'Passwort vergessen?'
  },
  password_remember: {
    nl: 'Ik weet mijn wachtwoord weer!',
    fr: 'Je me suis rappelé mon mot de passe!',
    en: "Wait! I remember my password!",
    de: 'Moment! Ich erinnere mich an mein Passwort!'
  },
  message_forgot: {
    nl: "Geen zorgen, gebeurt iedereen wel eens ;)",
    fr: "Ne vous inqui\xE9tez pas, cela arrive aux meilleurs d'entre nous;)",
    en: "Don't worry, it happens to the best of us ;)",
    de: "Keine Sorge, das passiert den Besten von uns ;)"
  },
  feedback_mail_empty: {
    nl: 'Gelieve een e-mail adres in te vullen',
    fr: "Rempli votre adresse e-mail s'il vous plaît",
    en: 'Please fill in your email address',
    de: 'Bitte geben Sie Ihre E-Mail-Adresse ein'
  },
  feedback_mail_incorrect: {
    nl: 'We vinden geen gegevens met dit e-mail adres; typfoutje gemaakt?',
    fr: "Nous ne pouvons trouver aucune donnée avec cette adresse e-mail; faute de frappe?",
    en: "We can't find any data with this e-mail address; made a typo?",
    de: "Wir können keine Daten mit dieser E-Mail-Adresse finden; Tippfehler gemacht?"
  },
  feedback_mail_wrong: {
    nl: 'Dit e-mail adres bestaat niet',
    fr: "Cette adresse e-mail n'existe pas",
    en: "This email address doesn't exist",
    de: 'Diese E-Mail-Adresse existiert nicht'
  },
  feedback_pw_empty: {
    nl: 'Wees niet bang om je wachtwoord in te vullen',
    fr: "N'ayez pas peur de saisir votre mot de passe",
    en: "Don't be afraid to fill in your password",
    de: 'Haben Sie keine Angst, Ihr Passwort einzugeben'
  },
  feedback_pw_incorrect: {
    nl: 'Oeps! Dit is niet het juiste wachtwoord. Probeer nog eens als je wilt?',
    fr: "Oups! Ce n'est pas le bon mot de passe. Essaie encore si tu veux?",
    en: 'Oops! This is not the correct password. Try again if you want?',
    de: 'Ups! Das ist nicht das richtige Passwort. Versuchen Sie es noch einmal, wenn Sie möchten?'
  },
  feedback_unkown: {
    nl: 'Er is een onbekend probleem; we kijken dit na.',
    fr: 'Il y a un problème inconnu. nous vérifions cela.',
    en: "There is an unknown problem; we'll check this.",
    de: 'Es gibt ein unbekanntes Problem; wir überprüfen das.'
  },
  mail_sent: {
    nl: 'E-mail is verzonden!',
    fr: 'Le courrier a été envoyé!',
    en: 'Mail has been sent!',
    de: 'E-Mail wurde gesendet!'
  },
  mail_sent_error: {
    nl: 'Kan geen mail verzenden',
    fr: 'Impossible d\'envoyer du courrier',
    en: 'Can\'t send mail',
    de: 'Kann keine E-Mail senden'
  },
  logo_alt: {
    nl: 'Logo Ondernemersnetwerk',
    fr: 'Logo Reseau Entrepreneurs',
    en: 'Logo Entrepreneursnetwork',
    de: 'Logo Unternehmernetzwerk'
  },
  i_am: {
    nl: 'Ik ben een...',
    fr: 'Je suis un...',
    en: 'I am an...',
    de: 'Ich bin ein...'
  },
  user: {
    nl: 'Gebruiker',
    fr: 'Utilisateur',
    en: 'User',
    de: 'Benutzer'
  },
  entrepreneur: {
    nl: 'Ondernemer',
    fr: 'Entrepreneur',
    en: 'Entrepreneur',
    de: 'Unternehmer'
  },
  log_in: {
    nl: 'Inloggen',
    fr: 'Connexion',
    en: 'Log in',
    de: 'Einloggen'
  },
  sign_in: {
    nl: 'Registreren',
    fr: 'Inscription',
    en: 'Sign up',
    de: 'Anmelden'
  },
  create_account: {
    nl: 'Maak account',
    fr: 'Créer un compte',
    en: 'Create account',
    de: 'Konto erstellen'
  },
  log_in_instead: {
    nl: 'Toch inloggen',
    fr: 'Connexion',
    en: 'Log in instead',
    de: 'Stattdessen einloggen'
  },
  publish: {
    nl: 'Publiceren',
    fr: 'Publier',
    en: 'Publish',
    de: 'Veröffentlichen'
  },
  login_error: {
    nl: 'Log eerst in alstublieft',
    fr: "S'il vous plait connectez-vous d'abord",
    en: 'Please login first',
    de: 'Bitte zuerst einloggen'
  },
  company_details: {
    nl: 'Bedrijfsgegevens',
    fr: "Détails de l'entreprise",
    en: 'Enterprise details',
    de: 'Firmendetails'
  },
  contact_options: {
    nl: 'Contacteer mij via:',
    fr: "Contactez moi via:",
    en: 'Contact me via:',
    de: 'Kontaktieren Sie mich über:'
  },
  firstname: {
    nl: 'Voornaam',
    fr: 'Prénom',
    en: 'Firstname',
    de: 'Vorname'
  },
  lastname: {
    nl: 'Achternaam',
    fr: 'Nom',
    en: 'Lastname',
    de: 'Nachname'
  },
  telephone: {
    nl: 'Telefoonnummer',
    fr: 'Numéro telephone',
    en: 'Telephone number',
    de: 'Telefonnummer'
  },
  cellphone: {
    nl: 'GSM-nummer',
    fr: 'Numéro de portable',
    en: 'Cellphone number',
    de: 'Handynummer'
  },
  email: {
    nl: 'E-mailadres',
    fr: 'Adresse e-mail',
    en: 'E-mail address',
    de: 'E-Mail-Adresse'
  },
  enterprise_name: {
    nl: 'Maatschappelijke naam',
    fr: "Nom d'entreprise",
    en: 'Enterprise name',
    de: 'Unternehmensname'
  },
  trade_name: {
    nl: 'Handelsnaam',
    fr: 'Nom commercial',
    en: 'Trade name',
    de: 'Handelsname'
  },
  vat_number: {
    nl: 'BTW nummer',
    fr: 'Numéro de TVA',
    en: 'VAT number',
    de: 'Umsatzsteuer-Identifikationsnummer'
  },
  enterprise_phone: {
    nl: 'Telefoonnummer van bedrijf',
    fr: "Numéro téléphone d'entreprise",
    en: 'Telephone number of enterprise',
    de: 'Telefonnummer des Unternehmens'
  },
  enterprise_mail: {
    nl: 'E-mailadres van bedrijf',
    fr: "Adresse e-mail d'entreprise",
    en: 'E-mail address of enterprise',
    de: 'E-Mail-Adresse des Unternehmens'
  },
  enterprise_fax: {
    nl: 'Fax van bedrijf',
    fr: "Fax d'entreprise",
    en: 'Fax of enterprise',
    de: 'Fax des Unternehmens'
  },
  contact_us: {
    nl: 'Contacteer ons',
    fr: 'Contactez-nous',
    en: 'Contact us',
    de: 'Kontaktieren Sie uns'
  },
  contact_me: {
    nl: 'Contacteer mij',
    fr: 'Contactez-moi',
    en: 'Contact me',
    de: 'Kontaktieren Sie mich'
  },
  contact: {
    nl: 'Contacteer',
    fr: 'Contacter',
    en: 'Contact',
    de: 'Kontakt'
  },
  contact_details: {
    nl: 'Contactgegevens',
    fr: 'Informations de contact',
    en: 'Contact details',
    de: 'Kontaktdaten'
  },
  enterprise_details: {
    nl: 'Bedrijfsgegevens',
    fr: "Informations d'entreprise",
    en: 'Enterprise details',
    de: 'Unternehmensdetails'
  },
  forgot_password: {
    nl: 'Wachtwoord vergeten?',
    fr: 'Mot de passe oublié?',
    en: 'Forgot password?',
    de: 'Passwort vergessen?'
  },
  please_enter_an_email: {
    nl: 'Gelieve een email in te vullen',
    fr: 'Veuillez saisir un e-mail',
    en: 'Please enter an email',
    de: 'Bitte geben Sie eine E-Mail-Adresse ein'
  },
  not_a_valid_email: {
    nl: 'Geen geldig email',
    fr: 'Pas un e-mail valide',
    en: 'Not a valid email',
    de: 'Keine gültige E-Mail'
  },
  please_enter_a_password: {
    nl: 'Gelieve wachtwoord in te vullen',
    fr: 'Veuillez entrer un mot de passe',
    en: 'Please enter a password',
    de: 'Bitte geben Sie ein Passwort ein'
  },
  password_8_characters: {
    nl: 'Wachtwoord moet minstens 8 karakters bevatten!',
    fr: 'Le mot de passe doit avoir au moins 8 caractères!',
    en: 'Password must have at least 8 characters!',
    de: 'Passwort muss mindestens 8 Zeichen haben!'
  },
  password_1_capital: {
    nl: 'Wachtwoord moet minstens 1 hoofdletter bevatten!',
    fr: 'Le mot de passe doit avoir au moins 1 majuscule!',
    en: 'Password must have at least 1 capital letter!',
    de: 'Passwort muss mindestens 1 Großbuchstaben enthalten!'
  },
  password_1_number: {
    nl: 'Wachtwoord moet minstens 1 cijfer bevatten',
    fr: 'Le mot de passe doit avoir au moins 1 chiffre',
    en: 'Password must have at least 1 number',
    de: 'Passwort muss mindestens 1 Zahl enthalten'
  },
  enter_password_repeat: {
    nl: 'Gelieve wachtwoord herhalen in te vullen',
    fr: 'Veuillez saisir le mot de passe répéter',
    en: 'Please enter password repeat',
    de: 'Bitte wiederholen Sie das Passwort'
  },
  passwords_do_not_match: {
    nl: 'Wachtwoorden komen niet overeen!',
    fr: 'Les mots de passe ne correspondent pas!',
    en: 'Passwords do not match!',
    de: 'Passwörter stimmen nicht überein!'
  },
  please_enter_enterprise_number: {
    nl: 'Gelieve jouw ondernemingsnummer in te vullen',
    fr: "Veuillez entrer votre numéro d'entreprise",
    en: 'Please enter your enterprise number',
    de: 'Bitte geben Sie Ihre Unternehmensnummer ein'
  },
  please_enter_establishment_number: {
    nl: 'Gelieve jouw vestigingsnummer in te vullen',
    fr: "Veuillez entrer votre numéro d'établissement",
    en: 'Please enter your establishment number',
    de: 'Bitte geben Sie Ihre Betriebsnummer ein'
  },
  please_enter_otp: {
    nl: 'Gelieve jouw OTP in te vullen',
    fr: 'Veuillez entrer votre OTP',
    en: 'Please enter your OTP',
    de: 'Bitte geben Sie Ihr OTP ein'
  },
  email_already_in_use: {
    nl: 'Dit emailadres is al in gebruik',
    fr: 'Cet e-mail est déjà utilisé',
    en: 'This email is already in use',
    de: 'Diese E-Mail wird bereits verwendet'
  },
  username_already_in_use: {
    nl: 'Deze gebruikersnaam is al in gebruik',
    fr: "Ce nom d'utilisateur est déjà utilisé",
    en: 'This username is already in use',
    de: 'Dieser Benutzername wird bereits verwendet'
  },
  please_enter_username: {
    nl: 'Gelieve een gebruikersnaam in te vullen',
    fr: "Veuillez entrer un nom d'utilisateur",
    en: 'Please enter a username',
    de: 'Bitte geben Sie einen Benutzernamen ein'
  },
  please_enter_first_name: {
    nl: 'Gelieve een voornaam in te vullen',
    fr: 'Veuillez entrer un prénom',
    en: 'Please enter a first name',
    de: 'Bitte geben Sie einen Vornamen ein'
  },
  please_enter_last_name: {
    nl: 'Gelieve een achternaam in te vullen',
    fr: 'Veuillez entrer un nom de famille',
    en: 'Please enter a last name',
    de: 'Bitte geben Sie einen Nachnamen ein'
  },
  please_confirm_account: {
    nl: 'Gelieve jouw account te bevestigen via de net verstuurde mail',
    fr: "Veuillez confirmer votre compte avec l'e-mail qui vient d'être envoyé",
    en: 'Please confirm your account with the email just sent',
    de: 'Bitte bestätigen Sie Ihr Konto mit der soeben gesendeten E-Mail'
  },
  password_successfully_changed: {
    nl: 'Wachtwoord succesvol aangepast!',
    fr: 'Mot de passe changé avec succès!',
    en: 'Password successfully changed!',
    de: 'Passwort erfolgreich geändert!'
  },
  please_log_in_first: {
    nl: 'Een onderneming volgen zonder een account is niet mogelijk',
    fr: "Suivre une entreprise sans compte n'est pas possible",
    en: 'Following an enterprise without an account is impossible',
    de: 'Ohne ein Konto ist es nicht möglich, einem Unternehmen zu folgen'
  },
  check_mail_password_reset: {
    nl: 'Check jouw mail om jouw wachtwoord aan te passen',
    fr: "Vérifiez votre email pour changer votre mot de passe",
    en: 'Check your email to change your password',
    de: 'Überprüfen Sie Ihre E-Mails, um Ihr Passwort zu ändern'
  }
};
var _default = Login;
exports["default"] = _default;